"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBCheckbox;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Global components
 * By Juan Rodrigo <jponceflores@svb.com> (www.svb.com)
 * Summary
 * This component renders a SVB checkbox
 */

/**
 * SVBCheckbox
 * @param {string} id - id attribute value for the input tag
 * @param {string} name - name attribute value for the input tag
 * @param {(string|number)} value - value attribute value for the input tag
 * @param {(string|number)} [label = ''] - Label to be displayed next to the checkbox
 * @param {boolean} [defaultChecked = false] - Value that determines if the checkbox is checked by default
 * @param {boolean} [disabled = false] - Value that determines if the checkbox is disabled
 * @param {boolean} [indeterminate = false] - Value that determines if the checkbox is in indeterminate state by default
 * @param {string} [extraClasses = ''] - Extra classes to be added to the button element
 * @param {function} onChange - Function to execute when the checkbox changes (gets clicked)
 * @returns JSX element
 */

function SVBCheckbox(props) {
  // Prop error handling
  let componentError = false;
  const typeCheck = (prop, types) => {
    if (!types.includes(typeof prop)) {
      console.log(typeof prop, types, types.includes(typeof prop));
      componentError = true;
    }
    return prop;
  };
  const id = typeCheck(props.id, ["string"]);
  const name = typeCheck(props.name, ["string"]);
  const value = typeCheck(props.value, ["string", "number"]);
  //const label = typeCheck(props.label, ["string", "number", "undefined"]);
  const label = props.label;
  const onChange = typeCheck(props.onChange, ["function"]);
  const defaultChecked = typeCheck(props.defaultChecked, ["boolean", "undefined"]) || false;
  const disabled = typeCheck(props.disabled, ["boolean", "undefined"]) || false;
  const indeterminate = typeCheck(props.indeterminate, ["boolean", "undefined"]) || false;
  const extraClasses = typeCheck(props.extraClasses, ["string", "undefined"]) || "";
  const extraLabelClasses = typeCheck(props.extraLabelClasses, ["string", "undefined"]) || "";
  const showColorCodes = typeCheck(props.showColorCodes, ["boolean", "undefined"]) || false;
  const colorCode = typeCheck(props.colorCode, ["string", "undefined"]) || "";
  const mainStyle = 'd-flex flex-row align-items-center' + extraClasses;

  // Prop error check
  if (componentError) return /*#__PURE__*/_react.default.createElement("p", null, "Invalid prop sent, check console for prop type errors.");

  // const checkboxRef = useRef(null);

  // useEffect(() => {
  //     if (indeterminate === true) checkboxRef.current.indeterminate = true;
  // }, []);

  return /*#__PURE__*/_react.default.createElement("span", {
    className: mainStyle
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    name: name,
    value: value,
    onChange: onChange,
    className: "form-check-input",
    id: id,
    defaultChecked: defaultChecked,
    disabled: disabled
  }), showColorCodes && /*#__PURE__*/_react.default.createElement("div", {
    className: "all-api-checkbox-color all-api-bg-".concat(colorCode)
  }), label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: extraLabelClasses !== null && extraLabelClasses !== void 0 ? extraLabelClasses : "m-1"
  }, label));
}
;
SVBCheckbox.propTypes = {
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onChange: _propTypes.default.func.isRequired,
  defaultChecked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  extraClasses: _propTypes.default.string,
  extraLabelClasses: _propTypes.default.string,
  showColorCodes: _propTypes.default.bool
};